import { render, staticRenderFns } from "./AgeConfirmationDeclined.vue?vue&type=template&id=dcd4d986&"
import script from "./AgeConfirmationDeclined.vue?vue&type=script&lang=ts&"
export * from "./AgeConfirmationDeclined.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports